import React, { useMemo } from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";

import VersionHistorySection from "../VersionHistorySection";
import { mapApprovalSubmissionHistory } from "./SwmsFormV3Serializer";
import styles from "../../../../SwmsMasters/SwmsMastersStyle.module.css";

export default function VersionApprovalHistoryModal({
  visible,
  onClose,
  approvalSubmissionHistory = [],
  swmsData = {},
  loading = false
}) {
  const versions = useMemo(
    () => mapApprovalSubmissionHistory(approvalSubmissionHistory, swmsData),
    [approvalSubmissionHistory, swmsData]
  );

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={onClose}
      maskClosable
      destroyOnClose
      width={900}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className={styles.ModalHeading}>Version &amp; Approval History</div>
              <hr className="v3-modal-hr" />
              <VersionHistorySection versions={versions} loading={loading} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
